<template>
  <CompanyWrapper>
    <Loading v-if="isLoading"></Loading>
    <NotEnglish v-if="isEnglishNotAvailable"></NotEnglish>
    <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
    <main
      class="main"
      v-if="!isLoading && !isEnglishNotAvailable && !isBadRequest"
    >
      <!-- パンくずリスト -->
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}company/summary` }"
            class="breadcrumb-trail__list--item__link"
          >
            EventList
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}company/event/${eventData.code}` }"
            class="breadcrumb-trail__list--item__link"
          >
            Detail
          </router-link>
        </li>
      </ol>
      <div class="event-title__area">
        <h1
          class="page-title"
          :style="`border-left: solid 15px ${eventData.text.event_color_code};`"
        >
          {{ eventData.name }}
        </h1>
        <figure>
          <img
            class="logo"
            :src="`https://tmf-virtualrun.jp/images/company/${eventData.text.image_file_name}`"
            alt=""
            height="167"
          />
        </figure>
      </div>
      <ul class="event-category-label__list margin-top25">
        <li class="event-category-label__list--item">
          {{ eventData.text.event_label }}
        </li>
      </ul>
      <p
        class="event-description"
        v-html="eventData.text.detail_description"
      ></p>
      <p class="event-description update-time">{{
        eventData.text.update_day
      }}</p>
      <section class="requirements-list">
        <dl class="requirements-list__dl">
          <dt class="item-team">
            {{ Event.name[lang] }}
          </dt>
          <dd class="detail-description">
            {{ eventData.name }}
          </dd>
        </dl>
        <template v-if="eventData.texts">
          <dl
            class="requirements-list__dl"
            v-for="(detail, index) in eventData.texts[0].details"
            :key="index"
          >
            <dt class="item-team" v-html="detail.label"></dt>
            <dd class="detail-description" v-html="detail.value"></dd>
          </dl>
        </template>
      </section>
      <div class="link-area">
        <!-- エントリー対応 -->
        <div>
          <template v-if="isEntryLink && !eventData.text.entry_page_flag">
            <a
              :href="`${eventData.text.entry_page_url}`"
              class="more-link entry icon-target-blank"
              target="_blank"
              rel="noopener"
              >Entry</a
            >
          </template>
          <template v-else>
            <div class="more-link gray-out icon-target-blank">Entry</div>
          </template>
        </div>
        <!-- ランキング対応 -->
        <div>
          <router-link
            :to="{
              path: `/${langPath}company/ranking`,
              query: { event: eventId, page: 1 },
            }"
            class="more-link ranking"
            v-if="isResultLink"
          >
            View Result
          </router-link>
          <div class="more-link gray-out" v-else>View Result</div>
        </div>
        <!-- OAuth対応 -->
        <div>
          <router-link
            v-if="isOauthLink"
            :to="{
              path: `/${langPath}company/confirmation`,
              query: { event: eventId },
            }"
            class="more-link oauth text-center"
          >
            {{ Event.link[lang] }}
          </router-link>
          <!-- 期間外 -->
          <div v-else class="more-link gray-out text-center">
            {{ Event.link[lang] }}
          </div>
        </div>
        <router-link
          :to="{ path: `/${langPath}company/howtojoin` }"
          class="more-link oauth text-center"
        >
          {{ Event.howtojoin[lang] }}
        </router-link>
        <router-link
          :to="{ path: `/${langPath}company/question` }"
          class="more-link oauth text-center"
        >
          {{ Event.question[lang] }}
        </router-link>
      </div>
    </main>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/pc/company/CompanyWrapper";
import Loading from "../../../../components/pc/Loading";
import BadRequest from "../../../../components/common/status/BadRequest";
import NotEnglish from "../../../../components/pc/NotEnglish";
import Event from "../../../../assets/constants/event/event";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import cognito from "../../../../plugins/cognito";

export default {
  data() {
    return {
      eventData: {},
      isLoading: true,
      eventId:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.path.split("/")[4]
          : this.$route.path.split("/")[3],
      isEntryLink: false,
      isOauthLink: false,
      isResultLink: false,
      isEnglishNotAvailable: false,
      isBadRequest: false,
    };
  },
  async created() {
    // イベント詳細を取得
    const EventRepository = RepositoryFactory.get("event");
    const isCompany = this.$route.path.includes("company");
    const params = {
      code:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.path.split("/")[4]
          : this.$route.path.split("/")[3],
      lang: this.lang,
      is_company_event: isCompany || "",
      company_user_name: cognito.getUserName() || "",
    };
    let response;
    try {
      response = await EventRepository.getEvent(params);
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        this.isLoading = false;
      }
      return;
    }
    this.eventData = response.data;

    // Entry期間
    this.isEntryLink = this.eventData.text.entry_date_flag;
    // OAuth期間
    this.isOauthLink = this.eventData.text.oauth_date_flag;
    // ランキング
    this.isResultLink = this.eventData.text.result_date_flag;

    // 英語ページの場合表示するかを判定
    if (this.lang === "en" && this.eventData.text.english_page_flag) {
      this.isEnglishNotAvailable = true;
    }

    this.isLoading = false;
  },
  computed: {
    Event: function () {
      return Event;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    CompanyWrapper,
    Loading,
    BadRequest,
    NotEnglish,
  },
  name: "Event",
};
</script>

<style scoped lang="scss">
.main {
  .event-title__area {
    margin: 78px 0 0 0;
    display: flex;
    align-items: center;
    .page-title {
      margin: 0 34px 0 0;
      padding: 0 0 0 25px;
      line-height: 1.3;
      font-size: 50px;
      font-weight: 900;
    }
  }
  .event-description {
    margin: 25px 0 0 0;
    line-height: 1.5;
    font-size: 16px;
    font-weight: 500;
  }
  .update-time {
    text-align: right;
  }
  .requirements-list {
    margin: 40px 0 0 0;
    border-bottom: solid 1px var(--grayColor3);
    &__dl {
      display: flex;
      border-top: solid 1px var(--grayColor3);
      border-left: solid 1px var(--grayColor3);
      border-right: solid 1px var(--grayColor3);
      .item-team {
        min-width: 210px;
        padding: 20px;
        line-height: 1.2;
        font-size: 24px;
        font-weight: bold;
        background-color: var(--defaultGrayColor);
      }
      .detail-description {
        padding: 20px;
        line-height: 1.5;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .link-area {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: 80px 0 0 0;
    position: relative;
    .more-link {
      width: 300px;
      height: 58px;
      margin: 0 0 40px 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px var(--defaultBlackColor);
      font-size: 16px;
      font-weight: 500;
      color: var(--defaultBlackColor);
    }
    .entry,
    .oauth,
    .ranking {
      &:hover {
        color: var(--defaultWhiteColor);
        background-color: var(--defaultBlackColor);
      }
    }
    .gray-out {
      border: solid 1px var(--grayColor4);
      color: var(--grayColor4);
    }
    .note {
      position: absolute;
      top: -24px;
      right: 160px;
    }
    .icon-target-blank {
      background: url("../../../../assets/images/target-blank.svg") no-repeat
        right 18px center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/company/event/Event.vue